import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";
import { typeLabels } from "@/mocks/content";

export default function ContentCard({ item }: { item: ContentItem }) {
  if (item.type === "news") {
    return (
      <Link
        to={`/detail/${item.id}`}
        className="group flex flex-col gap-4 rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
      >
        <div className="h-40 w-full shrink-0 overflow-hidden rounded-md sm:h-28 sm:w-44">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 快猫娱乐资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-accent-100 px-2 py-0.5 font-label font-medium text-accent-700">
              {typeLabels[item.type]}
            </span>
            <span>{item.date}</span>
          </div>
          <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{item.summary}</p>
          <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            {item.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-800">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    );
  }

  const isFilm = item.type === "film";

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className={`w-full overflow-hidden ${isFilm ? "aspect-[3/4]" : "aspect-square"}`}>
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 快猫${typeLabels[item.type]}推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-primary-100 px-2 py-0.5 font-label font-medium text-primary-700">
            {isFilm ? item.genre : item.musicGenre}
          </span>
          <span className="flex items-center gap-1 text-primary-600">
            <i className={`${isFilm ? "ri-star-fill" : "ri-headphone-line"} text-sm`} />
            {isFilm ? item.rating.toFixed(1) : `${item.album}`}
          </span>
        </div>
        <h3 className="mt-2 line-clamp-1 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-1 line-clamp-2 flex-1 text-sm text-foreground-600">{item.summary}</p>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
          <i className="ri-user-3-line" />
          <span>{item.author}</span>
        </div>
      </div>
    </Link>
  );
}